export * from './src';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/change-detection/decorator/index.js
// module id = 905
// module chunks = 7